import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';


class CRMInstanceName extends Component {
  render() {
    const { organization: { type } } = this.props;
    let name = 'CRM';
    if (type === 'azure') {
      name = 'Microsoft Dynamics';
    } else if (type === 'force') {
      name = 'Salesforce';
    } else if (type === 'hubspot') {
      name = 'HubSpot';
    }
    return (
      <span>
        {name}
      </span>
    );
  }
}

function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

CRMInstanceName.propTypes = {
  organization: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
};
CRMInstanceName.defaultProps = {
};

export default connect(mapStateToProps)(CRMInstanceName);
